import React, { useState, useEffect } from 'react';
import { IDebitmanagment } from '../../../types/repossession.type';
import { InfoTable } from '../../../common/components/ui/table/InfoTable';
import { useToastContext } from '../../../common/components/ui/toast/toast.context';
import { getVehicleById } from '../../../common/services/vehicles.api';
import { sendRepossessionDebitManagement } from '../../../common/services/debit-management.api';
import ButtonWithLoader from '../../../common/components/ui/loading/ButtonLoading';

interface NegotiationModalProps {
  initialIsOpen?: boolean;
  onClose: () => void;
  data?: IDebitmanagment;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TrafficFineSection = ({ title, data, className }: { title: string; data: { label: string; value: any }[]; className: string }) => (
  <section className={`tabs-item-style ${className}`}>
    <div>
      <InfoTable title={title} data={data} />
    </div>
  </section>
);

const DebtCollectionModal: React.FC<NegotiationModalProps> = ({
  initialIsOpen = false,
  onClose,
  data
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialIsOpen);
  const [debitmanagmentItem, setDebitmanagmentItem] = useState<IDebitmanagment | null>(null);
  const [namePartner, setNamePartner] = useState<string | null>(null);
  const [isLoaindButtonRepossesion, setIsLoaindButtonRepossesion] = useState<boolean>(false);

  const { notifySuccess, notifyError } = useToastContext()

  const handleSenRepossessin = async () => {
    try {
      setIsLoaindButtonRepossesion(true);

      const vehicleId = debitmanagmentItem?.renter?.vehicleId || "";
      const overdueDays = debitmanagmentItem?.daysOverdue || 0;
      const totalDebt = Number(debitmanagmentItem?.amount) || 0;
      const renter = {
        _id: debitmanagmentItem?.renter?.id || "",
        name: debitmanagmentItem?.renter?.name || "",
        whatsapp: debitmanagmentItem?.renter?.whatsapp || ""
      };

      const result = await sendRepossessionDebitManagement(vehicleId, overdueDays, totalDebt, renter);

      if (!result.ok) {
        return notifyError(result.message || 'Erro ao enviar para recolhimento');
      }

      return notifySuccess('Recolhimento enviado com sucesso');
    } catch (error) {
      notifyError('Erro ao enviar para recolhimento');
    } finally {
      setIsLoaindButtonRepossesion(false);
    }
  }


  const fetchData = async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { _original } = data as any || {};
    const result = _original as IDebitmanagment;
    setIsOpen(initialIsOpen);
    setDebitmanagmentItem(result || null);

    if (result?.renter?.partnerId) {
      try {
        const resultVehicle = await getVehicleById(result.renter.vehicleId || '');

        if (!resultVehicle.ok) {
          setNamePartner(null);
          return notifyError(resultVehicle.message || 'Erro ao buscar veículo');
        }

        setNamePartner(resultVehicle.data?.partnerInfo.companyName || null);
      } catch (error) {
        setNamePartner(null);
        notifyError('Erro ao buscar veículo');
      }
    }
  };

  useEffect(() => {

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialIsOpen, data, notifyError]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        role="dialog"
        aria-modal="true"
        onClick={handleClose}
      >
        <div
          className="bg-white p-4 rounded-md shadow w-full max-w-[75%] max-h-[95vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-lg font-bold mb-3 sticky top-0 bg-white">Enviar para recolhimento</h2>

          <div className="border-t dark:border-gray-600 overflow-y-auto flex-1">
            <div className="overflow-y-auto">
              <TrafficFineSection
                title="Cliente"
                className="mt-3 mb-2"
                data={[
                  { label: "Nome", value: debitmanagmentItem?.renter?.name || 'N/A' },
                  { label: "CPF", value: debitmanagmentItem?.renter?.cpf || 'N/A' },
                  {
                    label: "Whatsapp",
                    value: debitmanagmentItem?.renter?.whatsapp ?
                      <a
                        className="text-[#802d2d] hover:underline"
                        href={`https://wa.me/55${String(debitmanagmentItem.renter.whatsapp).replace(/\D/g, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {debitmanagmentItem.renter.whatsapp}
                      </a> : 'N/A'
                  },
                  {
                    label: "Valor em Aberto", value: debitmanagmentItem?.amount
                      ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(debitmanagmentItem.amount))
                      : 'N/A'
                  },
                  { label: "Atraso (em dias)", value: debitmanagmentItem?.daysOverdue || 'N/A' },
                  {
                    label: "Veículo de Parceiro",
                    value: debitmanagmentItem?.renter?.partnerId && !namePartner?.toUpperCase().includes("LOCAVIBE")
                      ? <span style={{ color: '#e53e3e', fontWeight: 'bold' }}>Sim</span>
                      : <span style={{ color: '#38a169', fontWeight: 'bold' }}>Não</span>
                  },
                ].concat(namePartner ? [{ label: "Proprietário", value: namePartner }] : [])}
              />
              <div className="mt-2 text-balance mb-2">
                <ButtonWithLoader
                  type="button"
                  isLoading={isLoaindButtonRepossesion}
                  onClick={handleSenRepossessin}
                >
                  Enviar para recolhimento
                </ButtonWithLoader>
              </div>

            </div>
            <div className="mt-4 text-right mb-2 sticky bottom-0 bg-white pt-2">
              <button
                onClick={handleClose}
                className="px-3 py-1 text-white rounded"
                style={{ backgroundColor: 'rgb(228, 65, 49)' }}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DebtCollectionModal;